import styled from '@emotion/styled';

import { OutlineLinkButton, TableActionButton } from '@/components/common/form/formPageStyles';
import { pageSectionLayout } from '@/styles/pageLayout';

export { OutlineLinkButton as Button, TableActionButton };

interface Props {
	noData?: boolean;
}
export const Container = styled.main<Props>`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	justify-content: ${(props) => (props.noData ? 'center' : '')};
`;
export const BackButton = styled.button`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 1.2rem 0;
	color: ${(props) => props.theme.colors.primary400};
	text-align: center;
	font-size: 1.6rem;
	font-weight: 700;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	background: none;
	border: none;
	cursor: pointer;
`;
export const TableBox = styled.ul`
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: #fff;
	border: 1px solid ${(props) => props.theme.colors.gray100};
	border-radius: ${(props) => props.theme.effects.radiusLg};
	box-shadow: ${(props) => props.theme.effects.shadowSm};
	overflow: hidden;
	padding: 0.8rem 2.4rem;
`;
export const TableItem = styled.li`
	display: flex;
	flex-direction: row;
	padding: 1.6rem 0;
	gap: 1.2rem;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid ${(props) => props.theme.colors.gray100};
	transition: background-color ${(props) => props.theme.effects.transitionFast};

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background-color: ${(props) => props.theme.colors.primary50};
	}
	@media (max-width: 900px) {
		align-items: flex-start;
		flex-direction: column;
	}
`;
export const TableContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	.date {
		color: #868e96;
		font-size: 1.4rem;
		line-height: ${(props) => props.theme.lineHeight.tight};
	}
	.abstract-info {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 1.6rem;
		color: #868e96;
		font-size: 1.4rem;
		line-height: ${(props) => props.theme.lineHeight.tight};
		> * + * {
			position: relative;
			&::before {
				content: '';
				position: absolute;
				left: -0.8rem;
				top: 50%;
				transform: translateY(-50%);
				width: 1px;
				height: 1.2rem;
				background-color: #d0d7de;
			}
		}
	}
`;
export const Badge = styled.span<{ status: 'approve' | 'reject' }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0.4rem;
	margin-left: 0.4rem;
	border-radius: 1.2rem;
	font-size: 1.2rem;
	font-weight: 500;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	background-color: ${(props) => (props.status === 'approve' ? '#E3F2FD' : '#F5F5F5')};
	color: ${(props) => (props.status === 'approve' ? '#1976D2' : '#757575')};
	border: 1px solid ${(props) => (props.status === 'approve' ? '#BBDEFB' : '#E0E0E0')};
`;
export const NoData = styled.p`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	font-size: 1.8rem;
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	padding: 8rem 0;
	white-space: nowrap;
`;
